import React from "react";
import LocalizedLink from "../localizedLink";
import useTranslationsCat from "../useTranslationsCat";
const CategoryNav = () => {
const {
thermometers,
digitalThermometers,
dataloggersTemperature,
analogThermometers,
thermographs,
remoteSensingDialThermometers,
rsdOrder,
rsdSp,
rsdWl,
rsdFl,
rsdSt,
rsdWp,
wpWl,
wpFl,
wpS,
wpT,
rsdO,
oWl,
oFl,
oS,
oT,
rsdEc,
ecWl,
ecFl,
ecSt,
ecWp,
ecRu,
rsdRc,
rsdDc,
bimetalThermometers,
bmOrder,
bmSp,
bmT,
bmS,
bmF,
bmR,
bmEc,
bmWp,
bmDc,
standardGlassThermometers,
glassThermometers,
thermocouples,
resistanceTemperatureDetectors,
thermohygrometers,
digitalThermohygrometers,
dataloggersTemperatureHumidity,
transmitters,
dialThermohygrometers,
thermohygrographs,
psychrometers,
anemometers,
heatStressMonitors,
infraredThermometers,
barometers,
digitalBarometer,
dialBarometers,
barograph,
recorders,
indicators,
weatherInstruments,
windSpeedDirectionIndicator,
anemometersWeatherInstruments,
rainGauge,
instrumentScreens,
moistureMeters,
refractometers,
phMeters,
timers,
timersSecondLayer,
stopwatches,
sandglasses,
optionalProbes,
forSkL751,
forSkL753,
forSkL754,
forSkL200TIISeries,
forSkL400tSk1110Sk1120Sk7000PRTII,
forSk1260,
forSk1250MCIIISk1250MCIIIa,
forSk270wpSeries,
forSk250wp2Series,
forSk100wp,
forSk810pt,
forSk110trhB,
forSkRhcSeries,
forSkM460TSkM350T,
forSk610ph2,
forSk660phSeries,
forSk620ph2Sk650ph,
forSk620ph,
chartsAndPens,
forSigma2Thermohygrographs,
forAurora903Thermohygrograph,
forSigma2Thermograph,
forSigma2Hygrograph,
forSigma2Barograph,
forSigma2RemoteThermographs,
forMiniCubeThermohygrograph,
forMiniStarThermohygrograph,
forMiniAlphaThermohygrograph,
forEventRecorder,
forLmmcTemperatureRecorder,
forVariousRecorders,
cartridgePens,
otherAccessories,
discontinuedProducts,
} = useTranslationsCat();const ActiveStyle = {backgroundColor: '#63B1BC',color: '#fff',width: 'auto',textAlign: 'center',}; return ( <ul className="menu__second-level"><li>
<LocalizedLink to="/categories/thermometers/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{thermometers}</LocalizedLink>
<ul className="menu__third-level">
<li>
<LocalizedLink to="/categories/thermometers/digital-thermometers/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{digitalThermometers}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/dataloggers-temperature/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{dataloggersTemperature}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/analog-thermometers/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{analogThermometers}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/thermographs/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{thermographs}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/remote-sensing-dial-thermometers/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{remoteSensingDialThermometers}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/rsd-order/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{rsdOrder}</LocalizedLink>
<ul className="menu__fourth-level">
<li>
<LocalizedLink to="/categories/thermometers/rsd-order/rsd-sp/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{rsdSp}</LocalizedLink>
<ul className="menu__fifth-level">
<li>
<LocalizedLink to="/categories/thermometers/rsd-order/rsd-sp/rsd-wl/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{rsdWl}</LocalizedLink>
<ul className="menu__sixth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/rsd-order/rsd-sp/rsd-fl/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{rsdFl}</LocalizedLink>
<ul className="menu__sixth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/rsd-order/rsd-sp/rsd-st/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{rsdSt}</LocalizedLink>
<ul className="menu__sixth-level">

</ul>
</li>

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/rsd-order/rsd-wp/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{rsdWp}</LocalizedLink>
<ul className="menu__fifth-level">
<li>
<LocalizedLink to="/categories/thermometers/rsd-order/rsd-wp/wp-wl/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{wpWl}</LocalizedLink>
<ul className="menu__sixth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/rsd-order/rsd-wp/wp-fl/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{wpFl}</LocalizedLink>
<ul className="menu__sixth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/rsd-order/rsd-wp/wp-s/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{wpS}</LocalizedLink>
<ul className="menu__sixth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/rsd-order/rsd-wp/wp-t/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{wpT}</LocalizedLink>
<ul className="menu__sixth-level">

</ul>
</li>

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/rsd-order/rsd-o/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{rsdO}</LocalizedLink>
<ul className="menu__fifth-level">
<li>
<LocalizedLink to="/categories/thermometers/rsd-order/rsd-o/o-wl/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{oWl}</LocalizedLink>
<ul className="menu__sixth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/rsd-order/rsd-o/o-fl/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{oFl}</LocalizedLink>
<ul className="menu__sixth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/rsd-order/rsd-o/o-s/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{oS}</LocalizedLink>
<ul className="menu__sixth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/rsd-order/rsd-o/o-t/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{oT}</LocalizedLink>
<ul className="menu__sixth-level">

</ul>
</li>

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/rsd-order/rsd-ec/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{rsdEc}</LocalizedLink>
<ul className="menu__fifth-level">
<li>
<LocalizedLink to="/categories/thermometers/rsd-order/rsd-ec/ec-wl/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{ecWl}</LocalizedLink>
<ul className="menu__sixth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/rsd-order/rsd-ec/ec-fl/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{ecFl}</LocalizedLink>
<ul className="menu__sixth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/rsd-order/rsd-ec/ec-st/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{ecSt}</LocalizedLink>
<ul className="menu__sixth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/rsd-order/rsd-ec/ec-wp/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{ecWp}</LocalizedLink>
<ul className="menu__sixth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/rsd-order/rsd-ec/ec-ru/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{ecRu}</LocalizedLink>
<ul className="menu__sixth-level">

</ul>
</li>

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/rsd-order/rsd-rc/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{rsdRc}</LocalizedLink>
<ul className="menu__fifth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/rsd-order/rsd-dc/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{rsdDc}</LocalizedLink>
<ul className="menu__fifth-level">

</ul>
</li>

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/bimetal-thermometers/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{bimetalThermometers}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/bm-order/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{bmOrder}</LocalizedLink>
<ul className="menu__fourth-level">
<li>
<LocalizedLink to="/categories/thermometers/bm-order/bm-sp/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{bmSp}</LocalizedLink>
<ul className="menu__fifth-level">
<li>
<LocalizedLink to="/categories/thermometers/bm-order/bm-sp/bm-t/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{bmT}</LocalizedLink>
<ul className="menu__sixth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/bm-order/bm-sp/bm-s/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{bmS}</LocalizedLink>
<ul className="menu__sixth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/bm-order/bm-sp/bm-f/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{bmF}</LocalizedLink>
<ul className="menu__sixth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/bm-order/bm-sp/bm-r/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{bmR}</LocalizedLink>
<ul className="menu__sixth-level">

</ul>
</li>

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/bm-order/bm-ec/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{bmEc}</LocalizedLink>
<ul className="menu__fifth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/bm-order/bm-wp/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{bmWp}</LocalizedLink>
<ul className="menu__fifth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/bm-order/bm-dc/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{bmDc}</LocalizedLink>
<ul className="menu__fifth-level">

</ul>
</li>

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/standard-glass-thermometers/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{standardGlassThermometers}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/glass-thermometers/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{glassThermometers}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/thermocouples/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{thermocouples}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermometers/resistance-temperature-detectors/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{resistanceTemperatureDetectors}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermohygrometers/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{thermohygrometers}</LocalizedLink>
<ul className="menu__third-level">
<li>
<LocalizedLink to="/categories/thermohygrometers/digital-thermohygrometers/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{digitalThermohygrometers}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermohygrometers/dataloggers-temperature-Humidity/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{dataloggersTemperatureHumidity}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermohygrometers/transmitters/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{transmitters}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermohygrometers/dial-thermohygrometers/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{dialThermohygrometers}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermohygrometers/thermohygrographs/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{thermohygrographs}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/thermohygrometers/psychrometers/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{psychrometers}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>

</ul>
</li>
<li>
<LocalizedLink to="/categories/anemometers/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{anemometers}</LocalizedLink>
<ul className="menu__third-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/heat-stress-monitors/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{heatStressMonitors}</LocalizedLink>
<ul className="menu__third-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/infrared-thermometers/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{infraredThermometers}</LocalizedLink>
<ul className="menu__third-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/barometers/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{barometers}</LocalizedLink>
<ul className="menu__third-level">
<li>
<LocalizedLink to="/categories/barometers/digital-barometer/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{digitalBarometer}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/barometers/dial-barometers/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{dialBarometers}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/barometers/barograph/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{barograph}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>

</ul>
</li>
<li>
<LocalizedLink to="/categories/recorders/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{recorders}</LocalizedLink>
<ul className="menu__third-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/indicators/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{indicators}</LocalizedLink>
<ul className="menu__third-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/weather-instruments/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{weatherInstruments}</LocalizedLink>
<ul className="menu__third-level">
<li>
<LocalizedLink to="/categories/weather-instruments/wind-speed-direction-indicator/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{windSpeedDirectionIndicator}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/weather-instruments/anemometers-weather-instruments/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{anemometersWeatherInstruments}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/weather-instruments/rain-gauge/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{rainGauge}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/weather-instruments/instrument-screens/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{instrumentScreens}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>

</ul>
</li>
<li>
<LocalizedLink to="/categories/moisture-meters/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{moistureMeters}</LocalizedLink>
<ul className="menu__third-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/refractometers/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{refractometers}</LocalizedLink>
<ul className="menu__third-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/ph-meters/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{phMeters}</LocalizedLink>
<ul className="menu__third-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/timers/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{timers}</LocalizedLink>
<ul className="menu__third-level">
<li>
<LocalizedLink to="/categories/timers/timers-second-layer/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{timersSecondLayer}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/timers/stopwatches/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{stopwatches}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/timers/sandglasses/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{sandglasses}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>

</ul>
</li>
<li>
<LocalizedLink to="/categories/optional-probes/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{optionalProbes}</LocalizedLink>
<ul className="menu__third-level">
<li>
<LocalizedLink to="/categories/optional-probes/for-sk-l751/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forSkL751}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/optional-probes/for-sk-l753/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forSkL753}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/optional-probes/for-sk-l754/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forSkL754}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/optional-probes/for-sk-l200TII-Series/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forSkL200TIISeries}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/optional-probes/for-sk-l400t-sk-1110-sk-1120-sk-7000PRTII/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forSkL400tSk1110Sk1120Sk7000PRTII}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/optional-probes/for-sk-1260/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forSk1260}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/optional-probes/for-sk-1250MCIII-sk-1250MCIIIa/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forSk1250MCIIISk1250MCIIIa}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/optional-probes/for-sk-270wp-series/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forSk270wpSeries}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/optional-probes/for-sk-250wp2-series/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forSk250wp2Series}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/optional-probes/for-sk-100wp/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forSk100wp}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/optional-probes/for-sk-810pt/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forSk810pt}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/optional-probes/for-sk-110trh-b/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forSk110trhB}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/optional-probes/for-sk-rhc-series/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forSkRhcSeries}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/optional-probes/for-sk-m460-t-sk-m350-t/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forSkM460TSkM350T}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/optional-probes/for-sk-610ph-2/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forSk610ph2}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/optional-probes/for-sk-660ph-series/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forSk660phSeries}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/optional-probes/for-sk-620ph2-sk-650ph/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forSk620ph2Sk650ph}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/optional-probes/for-sk-620ph/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forSk620ph}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>

</ul>
</li>
<li>
<LocalizedLink to="/categories/charts-and-pens/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{chartsAndPens}</LocalizedLink>
<ul className="menu__third-level">
<li>
<LocalizedLink to="/categories/charts-and-pens/for-sigma2-thermohygrographs/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forSigma2Thermohygrographs}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/charts-and-pens/for-aurora90-3-thermohygrograph/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forAurora903Thermohygrograph}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/charts-and-pens/for-sigma2-thermograph/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forSigma2Thermograph}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/charts-and-pens/for-sigma2-hygrograph/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forSigma2Hygrograph}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/charts-and-pens/for-sigma2-barograph/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forSigma2Barograph}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/charts-and-pens/for-sigma2-remote-thermographs/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forSigma2RemoteThermographs}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/charts-and-pens/for-mini-cube-thermohygrograph/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forMiniCubeThermohygrograph}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/charts-and-pens/for-mini-star-thermohygrograph/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forMiniStarThermohygrograph}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/charts-and-pens/for-mini-alpha-thermohygrograph/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forMiniAlphaThermohygrograph}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/charts-and-pens/for-event-recorder/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forEventRecorder}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/charts-and-pens/for-lmmc-temperature-recorder/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forLmmcTemperatureRecorder}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/charts-and-pens/for-various-recorders/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{forVariousRecorders}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/charts-and-pens/cartridge-pens/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{cartridgePens}</LocalizedLink>
<ul className="menu__fourth-level">

</ul>
</li>

</ul>
</li>
<li>
<LocalizedLink to="/categories/other-accessories/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{otherAccessories}</LocalizedLink>
<ul className="menu__third-level">

</ul>
</li>
<li>
<LocalizedLink to="/categories/discontinued-products/" activeStyle={ActiveStyle} partiallyActive={true} className="init-right line">{discontinuedProducts}</LocalizedLink>
<ul className="menu__third-level">

</ul>
</li>
</ul>);};export default CategoryNav;